export default {
  en: {
    label_add_todo: 'Add Todo',
  },
  'zh-TW': {
    label_add_todo: '添加待辦事項',
  },
};
